import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { Subject } from 'rxjs';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { AppInformationService, GenesisUnitOfWork } from '../../core/core.module';
import _ from 'lodash';
import { confirm, alert } from 'devextreme/ui/dialog';

@Component({
    selector: 'app-input-dialog',
    templateUrl: './input-dialog.component.html',
    styleUrls: ['./input-dialog.component.scss'],
    standalone: false
})
export class InputDialogComponent implements OnInit, AfterViewInit {
    result: Subject<any> = new Subject<any>();
    dialogHeader: string;
    dialogPrompt: string;
    dialogMessage: string;
    dialogValue: any;
    dialogValueArray: any[];
    otherValue: string;
    defaultValue: any;
    checkNumeric: boolean;
    checkInteger: boolean;
    minValue: number = null;
    selectionRequired: boolean;
    mode = 'text';
    saveAndNewVisible = false;
    processing = false;

    @ViewChild('inputComponent') inputComponent: any;

    constructor(public modalRef: BsModalRef, private uow: GenesisUnitOfWork, private appInfo: AppInformationService) {}

    async ngOnInit() {
        if (this.mode === 'selectWithOther') this.dialogValueArray = [...(this.dialogValueArray || []), 'Other'];
    }

    ngAfterViewInit() {
        setTimeout(() => {
            this.inputComponent.instance.focus();
        });
    }

    enterPressed() {
        if (this.mode !== 'textarea') this.save();
    }

    save(andNew?: boolean) {
        if (this.checkNumeric && isNaN(this.dialogValue)) {
            alert('Value needs to be a number', `${this.appInfo.settings.company}`);
            return;
        }
        if (this.checkInteger && (isNaN(this.dialogValue) || Number(this.dialogValue) !== Math.round(Number(this.dialogValue)))) {
            alert('Value needs to be an integer', `${this.appInfo.settings.company}`);
            return;
        }
        if (this.minValue != null && Number(this.dialogValue) < Number(this.minValue)) {
            alert(`Value needs to be greater than or equal to ${this.minValue}`, `${this.appInfo.settings.company}`);
            return;
        }
        if (!!this.selectionRequired && !this.dialogValue) {
            alert(`Selection Required`, `${this.appInfo.settings.company}`);
            return;
        }
        const value = this.mode === 'selectWithOther' && this.dialogValue === 'Other' ? this.otherValue?.trim() : this.dialogValue;
        if (!!this.selectionRequired && !value) {
            alert(`Value Required`, `${this.appInfo.settings.company}`);
            return;
        }
        if (andNew) {
        } else {
            this.processing = true;
            this.result.next({ result: true, value: value });
        }
    }

    cancel() {
        this.result.next({ result: false });
    }
}
